import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { useRef } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ShowAllToggleButton } from "web_myplann/Shared/Components/ShowAllToggleButton";
import { useTextTruncation } from "web_myplann/Shared/Hooks/useTextTruncation";
import { clampLinesSx } from "web_myplann/Shared/Utils/sxUtils";

type Props = {
	text: string;
};

export const AdvisorIntroduction: FC<Props> = ({ text }) => {
	const theme = useTheme();
	const { t } = useResource();
	const textRef = useRef<HTMLParagraphElement>(null);
	const { isTruncated, isExpanded, toggleExpanded } = useTextTruncation(
		textRef,
		[text],
	);

	return (
		<Stack width="100%" mt={theme.spacingTokens.xl}>
			<Stack
				px={theme.spacingTokens.lg}
				alignItems="flex-start"
				gap={theme.spacingTokens.sm}
			>
				<Typography variant="overline">
					{t(Resources.Advisor.introduction)}
				</Typography>
				<Typography
					ref={textRef}
					variant="body2"
					sx={{
						...clampLinesSx(isExpanded ? "unset" : 3),
						overflowWrap: "anywhere",
					}}
				>
					{text}
				</Typography>
			</Stack>
			{(isTruncated || isExpanded) && (
				<ShowAllToggleButton
					variant="disclosure"
					expanded={isExpanded}
					onClick={toggleExpanded}
					collapsedLabel={t(Resources.Advisor.showFull)}
				/>
			)}
		</Stack>
	);
};
